import React, { useState, useEffect } from 'react';
export function PolicyComponent() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    function checkMobile() {
      setIsMobile(window.innerWidth <= 768); // considera mobile se largura ≤ 768px
    }
    checkMobile(); // check inicial
    window.addEventListener('resize', checkMobile);
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
  const styleDesktop = {
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.2)',
    borderRadius: '6px',
    marginLeft: '5%',
    width: '80%',
    height: '80vh',
    backgroundColor: 'aliceblue',
    zIndex: '10',
    position: 'fixed',
    top: '10vh',
    left: '10vh',
    overflowY: 'auto',
    justifyItems: 'center',
  };
  const styleMobile = {
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.2)',
    borderRadius: '6px',
    marginLeft: '-23%',
    width: '95%',
    height: '80vh',
    backgroundColor: 'aliceblue',
    zIndex: '10',
    position: 'fixed',
    top: '2vh',
    left: '10vh',
    overflowY: 'auto',
    justifyItems: 'center',
  };
  return(
      <div
      className="policy"
      style={isMobile ? styleMobile : styleDesktop}
      >
      <div style={{width:'90%', margin:'5%', marginTop:'0'}}>
        <h2>Política de Privacidade e de Segurança de Dados do UrsoVerde</h2>
        <p><strong>1. Introdução</strong></p>
        <p>O UrsoVerde é uma aplicação móvel que promove e recompensa cidadãos por práticas de boa cidadania e hábitos de vida sustentável na cidade de Coimbra. A aplicação permite aos utilizadores ganhar pontos ao fazer scan de códigos QR através da câmara do dispositivo. Esta Política de Privacidade e de Segurança de Dados ("Política") descreve como o UrsoVerde recolhe, usa e protege as informações pessoais dos seus utilizadores. A Política aplica-se a todos os utilizadores do UrsoVerde, independentemente do local onde se encontrem. Ao utilizar o UrsoVerde, concorda com os termos desta Política. Se não concordar com os termos desta Política, não deve utilizar o UrsoVerde.</p>
        <p><strong>2. Recolha de Informações Pessoais</strong></p>
        <ul>
          <li><strong>Email:</strong> </li> <br/> <li> Recolhido quando o utilizador cria uma conta no UrsoVerde.</li><br/> 
          <li><strong>Localização:</strong> </li><br/> <li> Recolhida quando o utilizador faz scan de um código QR. Esta informação é utilizada para evitar fraudes.</li><br/> 
          <li><strong>Câmara:</strong> </li> <br/> <li> As imagens da câmara são recolhidas para digitalizar códigos QR.</li><br/> 
          <li><strong>Informação sobre as atividades do utilizador:</strong> </li> <br/> <li> Recolhida quando o utilizador utiliza o UrsoVerde, incluindo os códigos QR que o utilizador digitaliza e os pontos que o utilizador ganha.</li><br/> 
        </ul>
        <p><strong>3. Uso das Informações Pessoais</strong></p> 
        <p>O UrsoVerde utiliza as informações pessoais dos seus utilizadores para os seguintes fins:</p>
        <ul>
          <li><strong>Fornecer e melhorar o UrsoVerde:</strong> </li> <br/> <li> O UrsoVerde utiliza as informações pessoais dos seus utilizadores para fornecer e melhorar o UrsoVerde, incluindo para personalizar a experiência do utilizador, para prevenir fraudes e para solucionar problemas. O UrsoVerde não venderá ou alugará as informações pessoais dos seus utilizadores a terceiros.</li>
        </ul>
        <p><strong>4. Segurança das Informações Pessoais</strong></p>
        <p>O UrsoVerde toma medidas de segurança para proteger as informações pessoais dos seus utilizadores contra perda, roubo, uso indevido, acesso não autorizado, divulgação, alteração ou destruição. Estas medidas incluem:</p>
        <ul>
          <li><strong>Armazenamento seguro das informações pessoais:</strong> </li> <br/> <li> O UrsoVerde armazena as informações pessoais dos seus utilizadores num servidor seguro.</li> <br/>
          <li><strong>Uso de criptografia:</strong> </li> <br/> <li> O UrsoVerde utiliza criptografia para proteger as informações pessoais dos seus utilizadores quando estas são transmitidas pela Internet.</li> <br/>
          <li><strong>Restrição do acesso às informações pessoais:</strong> </li> <br/> <li> O UrsoVerde restringe o acesso às informações pessoais dos seus utilizadores aos funcionários que precisam de saber as informações para realizar o seu trabalho.</li> <br/>
        </ul>
        <p><strong>5. Retenção das Informações Pessoais</strong></p>
        <p>O UrsoVerde retém as informações pessoais dos seus utilizadores enquanto for necessário para cumprir os fins para os quais as informações foram recolhidas.</p>
        <p><strong>6. Direitos dos Utilizadores</strong></p>
        <p>Os utilizadores têm os seguintes direitos em relação às suas informações pessoais:</p>
        <ul>
          <li><strong>Acesso:</strong> O utilizador tem o direito de aceder às suas informações pessoais.</li>
          <li><strong>Retificação:</strong> O utilizador tem o direito de solicitar a retificação de suas informações pessoais se estiverem incorretas ou incompletas.</li>
          <li><strong>Apagar:</strong> O utilizador tem o direito que as suas informações pessoais sejam apagadas, o que é possível através da aplicação.</li>
        </ul>
        <p><strong>7. Cookies</strong></p>
        <p>Esta aplicação não necessita de cookies para funcionar.</p>
        <p><strong>8. Alterações nesta Política</strong></p>
        <p>Esta Política poderá ser atualizada de tempos em tempos. Se existirem alterações a esta Política, os utilizadores serão notificados através da aplicação.</p>
        <p><strong>9. Contacto</strong></p>
        <p>Se existir alguma dúvida sobre esta Política ou sobre as informações pessoais, os utilizadores deverão contactar o seguinte endereço de e-mail: <a style={{textDecoration: 'underline', color:'blue', fontSize: 'inherit'}} href="mailto:ursoverde.feedback@gmail.com?subject=Dúvidas%20sobre%20politica%20de%20dados">ursoverde.feedback@gmail.com</a></p>
        <p>Obrigado por usar o UrsoVerde!</p>
  
        <h2>Aviso: Utilizadores menores de 18 anos de idade</h2>
        <p>O tratamento dos dados pessoais dos utilizadores com menos de 18 anos depende do consentimento dos pais ou representantes legais e, preferencialmente, também do seu assentimento. No entanto, se o utilizador já tiver completado os 13 anos de idade, e se o tratamento dos seus dados ocorrer exclusivamente no âmbito de serviços da sociedade da informação, o seu consentimento é suficiente, mas atenção, nestes casos o utilizador pode, por exemplo, dar o seu consentimento para receber informações relativas a um produto ou serviços, mas não pode celebrar contratos nem assumir compromissos que envolvam pagamentos sem a autorização dos seus pais ou representantes legais.</p>
  
        <h2>Solicitação de Eliminação de Dados - UrsoVerde</h2>
        <p><strong>1. Introdução</strong></p>
        <p>Este documento descreve o processo de solicitação de eliminação de dados da aplicação UrsoVerde. O UrsoVerde é uma aplicação móvel que promove e recompensa cidadãos por práticas de boa cidadania e hábitos de vida sustentável na cidade de Coimbra.</p>
        <p><strong>2. Como solicitar a eliminação de dados</strong></p>
        <p>Para solicitar a eliminação dos dados do UrsoVerde, é necessário seguir estas etapas:</p>
        <ol>
          <li>Abrir a aplicação UrsoVerde e fazer Login com as credenciais que se pretende eliminar.</li> <br/>
          <li>Na página Home no canto superior direito carregar na ?? para aceder às Definições.</li><br/>
          <li>Selecionar a opção "Eliminar conta".</li><br/>
          <li>Confirmar a solicitação colocando a palavra-passe.</li><br/>
          <li>Após a palavra-passe ser corretamente inserida, a conta foi excluída.</li><br/>
        </ol>
        <p><strong>3. Dados excluídos e mantidos</strong></p>
        <p>Ao solicitar a eliminação da conta UrsoVerde, os seguintes dados serão excluídos:</p><br/>
        <ul>
          <li><strong>Informações do Utilizador:</strong> </li> <br/> <li>Endereço de e-mail.</li><br/>
          <li><strong>Dados de uso da aplicação:</strong> </li> <br/> <li>Informações sobre como a aplicação foi usada, como quais códigos QR foram digitalizados, quantos pontos ganhou e os prémios resgatados.</li><br/>
        </ul>
        <p><strong>4. Observações importantes</strong></p>
        <ul>
          <li>A exclusão da conta UrsoVerde é permanente e irreversível.</li><br/>
          <li>Após a exclusão da conta, não é possível aceder aos dados.</li><br/>
          <li>Para usar a aplicação é necessário criar uma conta nova.</li><br/>
          <li>Se tiver alguma dúvida sobre a eliminação de dados, o utilizador deve entrar em contato pelo endereço de e-mail fornecido na seção "Contacto" abaixo.</li><br/>
        </ul>
        <p><strong>5. Contacto</strong></p>
        <p>Se existir alguma dúvida, os utilizadores deverão contactar o seguinte endereço de e-mail: <a style={{textDecoration: 'underline', color:'blue', fontSize: 'inherit'}} href="mailto:ursoverde.feedback@gmail.com?subject=Exclusão%20de%20conta">ursoverde.feedback@gmail.com</a></p>
        <p>Obrigado por usar o UrsoVerde!</p>
      </div>
    </div>
    );
  }